import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Layout from '../layout';
import Lookbook from '../components/Lookbook/index.jsx';
import SEO from '../components/SEO/index.jsx';

class LookbookContainer extends Component {

	state = {
		garments: []
	}

  componentDidMount() {
		this.serializeGarments()
  }
	
	serializeGarments = () => {
		let garments = []
		this.props.data.allContentfulLookbook.edges.map(edge => {
			garments.push({
				name: edge.node.name,
				image: edge.node.image,
				garmentType: edge.node.product || "",
				organizationType: edge.node.organization.type || "",
				organizationName: edge.node.organization.name || ""
			})
		})
		this.setState({ garments })
	}

	render() {

		return (
			<Layout>
				<SEO 
					title="Lookbook - Greek Dressing"
					description="Our designers are the best in the biz. They can turn any idea into a fesh design, or come up with a completely new look for your organization." />
				<Lookbook garments={this.state.garments}/>
			</Layout>
		)
	}
}

export default LookbookContainer

export const LookbookQuery = graphql`
	query {
		allContentfulLookbook {
			edges {
				node {
					name
					product
					organization {
						type
						name
					}
					image {
						fluid(maxWidth: 300) {
							...GatsbyContentfulFluid_withWebp
						}
					}
				}
			}
		}  
	}
`
